import styled from 'styled-components';

import { theme } from './theme';

/** @deprecated use CDL Text instead */

export const Paragraph = styled.p`
    margin: 8px 0 0 0;
    font-weight: ${theme.fontWeights[400]};
    color: ${theme.colors.foreground.muted};
    line-height: 1.3;
    font-size: 14px;

    &:first-of-type {
        margin-top: 0;
    }
`;
